import { useFlags as useFeatureFlags } from "launchdarkly-react-client-sdk";

export type Flags = Partial<{
  feedbackFormEnabled: boolean;
  pdfCurriculumUnit: boolean;
  printCourseTvdEnabled: boolean;
  printCourseYagEnabled: boolean;
  printExamEnabled: boolean;
  printExamFeedbackEnabled: boolean;
  printPerformanceAssessmentEnabled: boolean;
  showActivityItemReplace: boolean;
  showCalendarManagement: boolean;
  showObjectiveSpecificityDiffToggleButton: boolean;
  showShuffleItems: boolean;
  textToSpeech: boolean;
  enableLoginWithClasslink: boolean;
  tcmpcAssessmentAppEnabled: boolean;
  tcmpcAssessmentAppShown: boolean;
}>;

export const useFlags = () => useFeatureFlags() as Flags;
